import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ImportExternalResultsService } from "src/app/_services/import-services/import-external-results.service";
import { catchError, map, switchMap } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";
import { 
  AuthorizeImportExternalResultsSSE, 
  AuthorizeImportExternalResultsSSEError, 
  AuthorizeImportExternalResultsSSESuccess, 
  CancelExternalResultsImport, 
  CancelExternalResultsImportError, 
  CancelExternalResultsImportSuccess, 
  ClearExternalResultsImportSession, 
  DownloadExternalResultsImportErrorList, 
  DownloadExternalResultsImportErrorListError, 
  DownloadExternalResultsImportErrorListSuccess, 
  HasImportedExternalResults, 
  HasImportedExternalResultsError, 
  HasImportedExternalResultsSuccess, 
  ResetExternalResultsImportState, 
  UploadExternalResultsCSV, 
  UploadExternalResultsCSVError, 
  UploadExternalResultsCSVSuccess } from "./import-external-results.action";

@Injectable()
export class ImportExternalResultsEffects {
  constructor(
    private actions$: Actions,
    private importExternalResultsService: ImportExternalResultsService
  ) {}

  public uploadExternalResultsCSVEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadExternalResultsCSV),
      switchMap((payload) =>
        this.importExternalResultsService.uploadCSVFile$(payload.payload).pipe(
          map((result: boolean) => {
            return UploadExternalResultsCSVSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(UploadExternalResultsCSVError({ error: error }));
          })
        )
      )
    )
  );

  public authorizeImportExternalResultsSSEEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthorizeImportExternalResultsSSE),
      switchMap(() =>
        this.importExternalResultsService.authorizeSSERequest$().pipe(
          map((result: boolean) => {
            return AuthorizeImportExternalResultsSSESuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(AuthorizeImportExternalResultsSSEError({ error: error }));
          })
        )
      )
    )
  );

  public hasImportedExternalResultsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HasImportedExternalResults),
      switchMap(() =>
        this.importExternalResultsService.hasImport$().pipe(
          map((result: number) => {
            return HasImportedExternalResultsSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(HasImportedExternalResultsError({ error: error }));
          })
        )
      )
    )
  );

  public downloadExternalResultsImportErrorListEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DownloadExternalResultsImportErrorList),
      switchMap(() =>
        this.importExternalResultsService.downloadErrorList$().pipe(
          map((result: string[]) => {
            return DownloadExternalResultsImportErrorListSuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(DownloadExternalResultsImportErrorListError({ error: error }));
          })
        )
      )
    )
  );

  public clearExternalResultsImportSessionEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClearExternalResultsImportSession),
      switchMap(() =>
        this.importExternalResultsService.clearImportSession$().pipe(
          map(() => {
            return ResetExternalResultsImportState();
          })
        )
      )
    )
  );

  public cancelExternalResultsImportEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CancelExternalResultsImport),
      switchMap(() =>
        this.importExternalResultsService.cancelImport$().pipe(
          map(() => {
            return CancelExternalResultsImportSuccess();
          }),
          catchError(() => {
            return of(CancelExternalResultsImportError());
          })
        )
      )
    )
  );
}